import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ProgressChartWrapper = styled.section`
  width: 320px;
  margin-right: ${Spacing.S40};
  margin-bottom: ${Spacing.S16};
`

export const ProgressChartHeader = styled.header`
  display: flex;
  flex-direction: row;
  margin-bottom: ${Spacing.S8};
`

export const ProgressBarWrapper = styled.div`
  height: 10px;
  border-radius: 25px;
  position: relative;
  background-color: ${Color.Grey150};
`

interface ProgressBarProps {
  barWidth: number
}

export const ProgressBar = styled.div<ProgressBarProps>`
  width: ${({ barWidth }) => `${barWidth}%`};
  height: 10px;
  border-radius: 25px;
  mask: linear-gradient(#fff 0 0);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(
      to right,
      ${Color.Green400} 0%,
      ${Color.Green400} 50%,
      ${Color.Yellow400} 75%,
      ${Color.Red700} 100%
    );
  }
`
